// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "group-1VDRp";
var _3 = "group__label-E0MOT";
export { _1 as "__esModule", _2 as "group", _3 as "group__label" }
export default { "__esModule": _1, "group": _2, "group__label": _3 }
